<script setup>
import { firstMeaningfulAlt, resolveMediaAlt } from '~/utils/resolveMediaAlt'

// TODO Use all image variants provided by Strapi
const props = defineProps({
  src: String,
  image: Object,
  id: {
    type: String,
    default: ''
  },
  alt: {
    type: String,
    default: ''
  },
  altFallback: {
    type: String,
    default: ''
  },
  loading: {
    type: String,
    default: 'lazy'
  },
  decoding: {
    type: String,
    default: 'async'
  },
  format: {
    type: String,
    default: null
  }
});
const { altFallback: pageAltFallback } = usePageAltFallback() || {};

const resolvedAlt = computed(() =>
  firstMeaningfulAlt(
    props.alt,
    resolveMediaAlt(props.image, pageAltFallback?.value, props.altFallback)
  )
);
</script>
<template>
  <NuxtImg
    v-bind="$attrs"
    :id="id"
    :src="src"
    :alt="resolvedAlt"
    :loading="loading"
    :decoding="decoding"
    :format="format"
  />
</template>

<style lang="scss" scoped>
img {
  border-radius: 24px;
}
</style>